export default __webpack_public_path__ + "static/media/smoke.b007ef3b.png";